var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inventory-buttons margin-top-2"},[_c('button',{staticClass:"button-gemnote-light button-gemnote--small",on:{"click":_vm.emitExport}},[_c('span',[_vm._v(" Export Inventory")])]),_vm._v("\n   \n  "),_c('button',{staticClass:"button-gemnote button-gemnote--small",class:{
      'button-gemnote--disabled':
        _vm.isReplenishProducts || !_vm.productsToReplenish.length
    },attrs:{"disabled":_vm.isReplenishProducts || !_vm.productsToReplenish.length},on:{"click":_vm.emitReplenish}},[_c('span',[_vm._v("Request restock")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }